import { render, staticRenderFns } from "./expected-recent-data.vue?vue&type=template&id=53d9ed82&scoped=true&"
import script from "./expected-recent-data.vue?vue&type=script&lang=js&"
export * from "./expected-recent-data.vue?vue&type=script&lang=js&"
import style0 from "./expected-recent-data.vue?vue&type=style&index=0&id=53d9ed82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d9ed82",
  null
  
)

component.options.__file = "expected-recent-data.vue"
export default component.exports